import {Component, Input} from '@angular/core';

/**
 * FormPageComponent — shared page-title bar used across all form pages
 * (entry-form, invoice-form, etc.).
 *
 * Renders:
 *  - Optional action icon buttons (Change Batch, Audit Trail, History) when an
 *    existing record id is supplied via [recordId].
 *  - A page title composed of [statusLabel] + [typeName] + [docLabel].
 *  - A right-aligned status badge driven by [locked] and optional [paid] /
 *    [printed] flags.
 *
 * Usage example:
 *   <app-form-page
 *     [recordId]="vm.item.header.id"
 *     [statusLabel]="vm.item.header.id ? (buttonsDisabled ? 'Posted' : 'Edit') : 'New'"
 *     [typeName]="vm.entryTypeName"
 *     [docLabel]="'Entry'"
 *     [locked]="vm.item.batch.locked"
 *   ></app-form-page>
 */
@Component({
  selector: 'app-form-page',
  templateUrl: './form-page.component.html',
  styleUrls: ['./form-page.component.css'],
  standalone: false,
})
export class FormPageComponent {
  /** The id of the current record — controls visibility of action icon buttons. */
  @Input() recordId: any;

  /** Text shown before typeName, e.g. "New", "Edit", "Posted". */
  @Input() statusLabel: string = '';

  /** The document type name, e.g. "Journal", "AR Invoice". */
  @Input() typeName: string = '';

  /** The document kind label, e.g. "Entry", "Invoice". */
  @Input() docLabel: string = '';

  /**
   * Batch locked state.
   * true  → Posted (green badge)
   * false → Not Posted (yellow badge)
   * null/undefined → no badge
   */
  @Input() locked: boolean | null = null;

  /** When true shows a "Printed" / "Not Printed" badge. */
  @Input() printed: boolean | null = null;

  /** When true shows a "Paid" badge. */
  @Input() paid: boolean = false;

  /** When true shows a "Shipped" badge. */
  @Input() shipped: boolean = false;

  /** When true shows a "Completed & Invoiced" badge. */
  @Input() invoiced: boolean = false;
}
